import React, { useState, useEffect } from "react";
import axios from "axios";
import { environment } from "../../../environment.js";
import { Button } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Link } from "react-router-dom";
import Loader from "../../Components/Loader.js";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import NavbarNew from "../../Components/NavbarNew.js";
const { SearchBar } = Search;

const MySwal = withReactContent(Swal);

const ManagerReturnShipments = ({ history, match, props }) => {
  const [notification, setNotification] = useState([]);
  const [shipments, setShipments] = useState([]);

  let partnerDetails;
  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ];
  //   alertArray = JSON.parse(localStorage.getItem("alertArray"));
  //   console.log(alertArray);
  //setNotification({ notification: alertArray });
  const deleteHandler = (dataField) => {
    // alert(dataField);
    // delete the device from database
    console.log("deleting");
    console.log(dataField);
    MySwal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(function (result) {
      if (result.isConfirmed) {
        removeShipmentStatus(dataField);
        deleteShipment(dataField);
      }
    });
  };

  const deleteShipment = async (dataField) => {
    axios
      .delete(
        environment.dap_url + "shipmentApi/deleteShipment?_id=" + dataField
      )
      .then(async (res) => {
        console.log(res.data.data);
        MySwal.fire({
          title: <p>Shipment has been deleted!</p>,
          type: "success",
        }).then((result) => {
          partnerDetails = JSON.parse(localStorage.getItem("managerdetails"));
          getShipments(partnerDetails.data);
        });
      })
      .catch((err) => {
        console.log(err);
        MySwal.fire({
          title: (
            <p>{err?.response?.data?.message || "Something went wrong!"}</p>
          ),
          type: "error",
        });
      });
  };

  const removeShipmentStatus = (dataField) => {
    axios
      .get(environment.dap_url + "shipmentApi/getByIdWithLogs?_id=" + dataField)
      .then((res) => {
        console.log(res.data.shipmentDetails[0].shipmenboxes);
        const myData = res.data.shipmentDetails[0].shipmenboxes;

        let myArray = [];
        myData.forEach((myBox) =>
          myBox.shipmentDevices.forEach((myDevice) =>
            axios
              .put(
                environment.dap_url +
                  "devices/updateShipment?deviceId=" +
                  myDevice.deviceIdMongo,
                { inShipment: false }
              )
              .then((resp) => {
                console.log(resp.data);
              })
              .catch((err) => {
                console.log(err);
              })
          )
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    let partnerDetail = JSON.parse(localStorage.getItem("managerdetails"));
    partnerDetails = partnerDetail.data;
    console.log(partnerDetails, "aaaaaaaaaaaaaaaaaaa");
    // setInterval(sayHi, 5000);
    // getAlerts();
    getShipments(partnerDetails);
  }, []);

  const getShipments = (partnerDetails) => {
    console.log(partnerDetails, "aaaaaaaaaaaaaaaaaaa");
    setShipments([]);
    axios
      .get(
        environment.dap_url +
          "shipmentApi/getByConsignorIdWithLogs?consignorId=" +
          partnerDetails.createdBy
      )
      // .get(
      //   environment.dap_url +
      //     "shipmentApi/getByConsigneeIdWithLogs?consigneeId=63591c4bccf2257f4673e7e2"
      // )
      .then((res) => {
        //setNotification(alertArray);
        console.log(res.data, "1234466");
        const mydata = res.data;
        const userData = JSON.parse(localStorage.getItem("user"));
        const filteredData = mydata.filter(
          (item) => item.isShipmentReturn == true && item.createdBy == userData._id
        );
        setShipments(filteredData.reverse());
      })
      .catch((err) => {});
  };
  const formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };
  const columns = [
    {
      dataField: "sl.no",
      text: "#",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
      sort: true,
    },
    {
      dataField: "shipmentUniqueId",
      text: "Shipment ID",
      sort: true,
    },
    {
      dataField: "consigneedetails[0].userFirstName",
      text: "Partner",
      sort: true,
    },
    {
      dataField: "consignordetails[0].userFirstName",
      text: "Consignor",
      sort: true,
    },
    {
      dataField: "consignmentState",
      text: "State",
      sort: true,
    },
    {
      dataField: "consignmentCountry",
      text: "Country",
      sort: true,
    },
    {
      dataField: "address",
      text: "Address",
      sort: true,
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,

      formatter: (dataField) => {
        return (
          <div>
            {dataField == 0 ? (
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style={{ backgroundColor: "#6867AC" }}
              >
                Initalized
              </button>
            ) : dataField == 1 ? (
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style={{
                  backgroundColor: "#59a9eb",
                  borderColor: "#59a9eb",
                }}
              >
                Finalized
              </button>
            ) : dataField == 5 ? (
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style={{
                  backgroundColor: "#E6B566",
                  borderColor: "rgb(230, 181, 102)",
                }}
              >
                In - Transit
              </button>
            ) : dataField == 3 ? (
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style={{
                  backgroundColor: "#1c7306",
                  borderColor: "#1c7306",
                }}
              >
                Approved
              </button>
            ) : dataField == 4 ? (
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style={{
                  backgroundColor: "rgb(233, 6, 6)",
                  borderColor: "rgb(233, 6, 6)",
                }}
              >
                Rejected
              </button>
            ) : dataField == 6 ? (
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style={{
                  backgroundColor: "#E6B566",
                  borderColor: "rgb(230, 181, 102)",
                }}
              >
                shipment received
              </button>
            ) : dataField == 7 ? (
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style={{
                  backgroundColor: "#E6B566",
                  borderColor: "rgb(230, 181, 102)",
                }}
              >
                All Boxes Received
              </button>
            ) : dataField == 8 ? (
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style={{
                  backgroundColor: "#E6B566",
                  borderColor: "rgb(230, 181, 102)",
                }}
              >
                All device Installed
              </button>
            ) : (
              ""
            )}
            {/* {(() => {
              switch (dataField) {
                case 0:
                  return "Initialized";
                case 1:
                  return "Finalized";
                case 3:
                  return "Approved";
                case 4:
                  return "Rejected";
                case 5:
                  return "In Transit";
                case 6:
                  return "shipment received";
                case 7:
                  return "All boxes Received";
                case 8:
                  return "All device Installed";
                default:
                  return "";
              }
            })()} */}
          </div>
        );
      },
    },
    {
      dataField: "createdAt",
      text: "Date",
      sort: true,
      formatter: (dataField) => {
        return formatDate(dataField);
      },
    },
    {
      dataField: "docketNo",
      text: "Docket No.",
      sort: true,
    },

    {
      dataField: "_id",
      text: "Action",
      sort: false,
      formatter: (dataField) => {
        var disable = false;
        shipments.every((element) => {
          if (element._id == dataField && element.status >= 1) {
            disable = true;
            return false;
          } else {
            disable = false;
            return true;
          }
        });
        return (
          <div>
            <LinkContainer
              to={"/shipment/detail/" + dataField}
              style={{
                float: "center",
              }}
            >
              <Button variant="light" className="btn-sm">
              <i className="fa fa-eye "></i>
              </Button>
            </LinkContainer>
            <LinkContainer
              to={"managerreturnshipment/edit/" + dataField}
              style={{
                float: "center",
              }}
            >
              <Button variant="info" className="btn-sm" disabled={disable}>
                <i className="fa fa-edit "></i>
              </Button>
            </LinkContainer>
            <Button
              variant="danger"
              className="btn-sm"
              disabled={disable}
              onClick={() => deleteHandler(dataField)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          </div>
        );
      },
    },
  ];
  return (
    <div class="container-fluid">
      <NavbarNew />
      <div className="row" style={{ marginTop: "2%" }}>
        <div className="col-lg-6">
          {/* <Link to="/customers" className="btn btn-light my-3">
              Go Back
            </Link> */}
        </div>
        <div className="col-lg-6">
          <LinkContainer
            to={`/create/returnshipment`}
            style={{
              // marginLeft: "80%",
              // verticalAlign: "bottom",
              paddingTop: "18px",
              float: "right",
            }}
          >
            <Button variant="light" className="btn btn-light my-3">
              Add Return Shipment
            </Button>
          </LinkContainer>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <h4 className="card-title" style={{ marginLeft: "2%" }}>
            RETURN SHIPMENTS
          </h4>
          <div className="row" style={{ marginLeft: "10px" }}>
            <div className="col-12">
              <ToolkitProvider
                keyField="id"
                bootstrap4
                data={shipments}
                columns={columns}
                search
              >
                {(props) => (
                  <div>
                    <div className="d-flex align-items-center">
                      <p className="mb-2 mr-2">Search in table:</p>
                      <SearchBar {...props.searchProps} />
                    </div>
                    <BootstrapTable
                      defaultSorted={defaultSorted}
                      pagination={paginationFactory()}
                      {...props.baseProps}
                      wrapperClasses="table-responsive"
                    />
                  </div>
                )}
              </ToolkitProvider>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManagerReturnShipments;
